import { render, staticRenderFns } from "./slidePicList.vue?vue&type=template&id=6ae8ede2&scoped=true&"
import script from "./slidePicList.vue?vue&type=script&lang=js&"
export * from "./slidePicList.vue?vue&type=script&lang=js&"
import style0 from "./slidePicList.vue?vue&type=style&index=0&id=6ae8ede2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae8ede2",
  null
  
)

export default component.exports